import styled from 'styled-components/macro';
import { space, flexbox, SpaceProps, FlexboxProps } from 'styled-system';

export const Content = styled.div`
  min-height: calc(100vh - 133px);

  @media screen and (min-width: 767px) {
    min-height: calc(100vh - 167px);
  }
`;

type CustomContentProps = {
  isOpen?: boolean;
};
type ContainerProps = SpaceProps & FlexboxProps & CustomContentProps;

export const Container = styled.div<ContainerProps>`
  display: flex;
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;
  max-width: 1200px;
  filter: ${(props) => (props.isOpen ? 'blur(2px)' : null)};
  transition: all 0.3s;
  height: fit-content;
  justify-content: center;
  ${space}
  ${flexbox}

  @media screen and (max-width: 767px) {
    margin-top: calc(${(props) => props.theme.header.height.mobile} + 15px);
    flex-direction: column;
    padding: 0 2.5%;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (min-width: 768px) {
    width: 66%;
  }
`;

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 33%;
  margin-left: 32px;
  @media screen and (max-width: 767px) {
    position: relative;
  }
`;
